import { url } from '@exodus/fetch/url';
const GET_ORDERS_DEFAULT_LIMIT = 100;
class OrdersService {
    #baseUrl;
    #appName;
    #appPlatform;
    #appVersion;
    #fetchival;
    constructor({ baseUrl, appName, appVersion, appPlatform, fetchival, }) {
        this.#baseUrl = new URL(baseUrl);
        this.#appName = appName;
        this.#appPlatform = appPlatform;
        this.#appVersion = appVersion;
        this.#fetchival = fetchival;
    }
    async insertDex(params, options) {
        return this.#request(url `${this.#baseUrl}/decentralized-orders`, options).post(params);
    }
    async updateDex(params) {
        return this.#request(url `${this.#baseUrl}/decentralized-orders/${params.id}`).patch({
            transactionId: params.transactionId,
            ...(params.providerOrderId ? { providerOrderId: params.providerOrderId } : {}),
        });
    }
    async getOrder(id) {
        return this.#request(url `${this.#baseUrl}/orders/${id}`).get();
    }
    async getOrders(params) {
        if (params.providerOrderIds?.length === 0)
            return [];
        return this.#request(url `${this.#baseUrl}/orders`).get({
            ...params,
            limit: params.limit ?? GET_ORDERS_DEFAULT_LIMIT,
        });
    }
    #request(url, { anonymousId } = {}) {
        return this.#fetchival(url, {
            headers: {
                'App-Name': this.#appName,
                'App-Version': this.#appVersion,
                ...(this.#appPlatform ? { 'App-Platform': this.#appPlatform } : {}),
                ...(anonymousId ? { anonymousId } : {}),
            },
        });
    }
}
export default OrdersService;
